const CryptoJS = require("crypto-js");
const crypto = require("crypto");

export const encrypt = message => {
  return CryptoJS.AES.encrypt(message, process.env.REACT_APP_CRYPTO_KEY).toString();
};

export const decrpt = message => {
  var bytes = CryptoJS.AES.decrypt(message, process.env.REACT_APP_CRYPTO_KEY);
  return bytes.toString(CryptoJS.enc.Utf8);
};

export const authHash = () => {
  return crypto.createHmac("sha512", process.env.REACT_APP_API_KEY)
      .update( process.env.REACT_APP_APP_ID)
      .digest("hex");
}